
(function(template){
    define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/onetimeServiceBooker',['Vue','vuex','vue!basicComponents/checkBox','vue!basicComponents/serviceCounter','vue!./packageItem','helpers','vuejsDatepicker','vue!basicComponents/loadingIndicator','vue!../packageScheduleComponent/container', 'vue!app/views/vue/components/cartComponent/cartBody/scheduleButtonComponent'],function (Vue,vuex,checkBox,serviceCounter,packageItem,helpers,vuejsDatepicker, loadingIndicator, packageSched, schedBtn) {
        return {
            template: template,
            props: ['selected', 'service'],
            components: {
                'check-box': checkBox,
                'service-counter': serviceCounter,
                'package-item' : packageItem,
                "vuejs-datepicker": vuejsDatepicker,
                'loading-indicator': loadingIndicator,
                'pkg-sched': packageSched,
                'schedule-btn' : schedBtn
            },
            data: function () {
                return {
                    
                };
            },
            computed: _.extend(
            vuex.mapState([
            "users",
            'bookingProgressPerUser',
            "desktopMode",
            "currentlyEditingService",
            "isFetching",
            "activePackageItem",
            "status",
            "activeUser",
            "selectedServices",
            "afterDeleteData",
            "usersWithIds", "HiddenReservedPackageItems", "ActiveUserCalenderEvents", "selectedDateOnDateBar", "bookingButtonText", "bookForAllGuestCheckBox", "errorMessage", 'loggedInUser', 'dataForBookingService', 'activeStep', 'bookFromCart','detectedChanges', 'selectedDateTimeOnTimePicker','selectedTimeOnTimePicker','editingFolioItemId'
            ]),{
            username: function(){
                        return Object.keys(this.users)[this.activeUser];
            },
            itemId: function(){
            return Object.keys(this.users[this.username])[
                this.currentlyEditingService]
            },
            isServiceBooked: function () {
                if(this.username && this.itemId)  
                    return !!this.users[this.username][this.itemId].SpaFolioItemId
                
            }
            }),
            watch: {
            selectedCalenderDate: function(val){
                var newDate = moment(val).format("YYYY-MM-DD");
                this.$store.commit("setselectedDateOnDateBar",newDate)
                !this.isFetching && !this.isServiceBooked?  this.selectDate(val):''   //is fetching is important because if user is not on scheduling screen and clicks pencil button, editMode function in parent class triggeres. So in that case if this selectDate also triggers on mount, it will result in multiple calls. To prevent it I have added isFetching which will prevent it from Wrunning second time.
            }
            },
            methods: _.extend(vuex.mapMutations(['addService', 'setActiveStep','addGlobalMessage','SetmobileViewMessages']), {
                
            }),
            events: {
            },
        }
    });
})('<div class="service-onetime-booker"> <pkg-sched :service="service"></pkg-sched> <schedule-btn v-show="selectedTimeOnTimePicker" v-bind:is_service_booked="isServiceBooked"></schedule-btn> </div>');
